"use strict";

var _classCallCheck = require("/Users/nathanmartin/Developer/projects/blockstack/a-dark-screen/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/nathanmartin/Developer/projects/blockstack/a-dark-screen/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/Users/nathanmartin/Developer/projects/blockstack/a-dark-screen/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/Users/nathanmartin/Developer/projects/blockstack/a-dark-screen/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _get = require("/Users/nathanmartin/Developer/projects/blockstack/a-dark-screen/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/get");

var _inherits = require("/Users/nathanmartin/Developer/projects/blockstack/a-dark-screen/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var cheerio = require("cheerio");

var service_1 = require("./service");

var HackerNews =
/*#__PURE__*/
function (_service_1$Service) {
  _inherits(HackerNews, _service_1$Service);

  function HackerNews() {
    _classCallCheck(this, HackerNews);

    return _possibleConstructorReturn(this, _getPrototypeOf(HackerNews).apply(this, arguments));
  }

  _createClass(HackerNews, null, [{
    key: "getBaseUrls",
    value: function getBaseUrls() {
      var baseUrls = ['https://news.ycombinator.com/user?id=', 'http://news.ycombinator.com/user?id=', 'news.ycombinator.com/user?id='];
      return baseUrls;
    }
  }, {
    key: "getProofUrl",
    value: function getProofUrl(proof) {
      var baseUrls = this.getBaseUrls();

      var proofUrl = _get(_getPrototypeOf(HackerNews), "prefixScheme", this).call(this, proof.proof_url);

      for (var i = 0; i < baseUrls.length; i++) {
        if (proofUrl === "".concat(baseUrls[i]).concat(proof.identifier)) {
          return proofUrl;
        }
      }

      throw new Error("Proof url ".concat(proof.proof_url, " is not valid for service ").concat(proof.service));
    }
  }, {
    key: "normalizeUrl",
    value: function normalizeUrl(proof) {
      return '';
    }
  }, {
    key: "getProofStatement",
    value: function getProofStatement(searchText) {
      var $ = cheerio.load(searchText);
      var tables = $('#hnmain').children().find('table');
      var statement = '';

      if (tables.length > 0) {
        tables.each(function (tableIndex, table) {
          var rows = $(table).find('tr');

          if (rows.length > 0) {
            rows.each(function (idx, row) {
              var heading = $(row).find('td').first().text().trim();

              if (heading === 'about:') {
                statement = $(row).find('td').last().text().trim();
              }
            });
          }
        });
      }

      return statement;
    }
  }]);

  return HackerNews;
}(service_1.Service);

exports.HackerNews = HackerNews;